import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../redux/store";
import { getHeader } from "../services/user";
import axios from "axios";
import { OrderInspectionState } from "../types/OrderInspectionState";
import { sendGAEvent } from "../services/AnalyticsService";
import { ORDER_INSPECTION, QUOTATION_CLICK } from "../utils/analytics";

const initialState: OrderInspectionState = {
    showModal: false,
    minimalInspection: undefined,
    postOrderInspectionStatus: "idle",
}


export const orderInspectionSlice = createSlice({
    name: "orderInspectionSlice",
    initialState,
    reducers: {
        toggleOrderInspectionModal: (state) => {
            state.showModal = !state.showModal;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(postOrderInspectionThunk.pending, (state) => {
            state.postOrderInspectionStatus = "pending";
        })
        .addCase(postOrderInspectionThunk.rejected, (state) => {
            state.postOrderInspectionStatus = "rejected";
        })
        .addCase(postOrderInspectionThunk.fulfilled, (state, action) => {
            const response = action.payload as any;

            state.minimalInspection = response.data;

            state.postOrderInspectionStatus = "fulfilled";
            state.showModal = true;
        })
    }
})

export const postOrderInspectionThunk = createAsyncThunk(
    "orderInspection/post",
    async (id : string) => {
        const header = await getHeader();
        sendGAEvent(QUOTATION_CLICK, ORDER_INSPECTION);
        const url = process.env.REACT_APP_QUOTATION_API_ENDPOINT + "/quotation/" + id + "/inspection/order";
        return axios.post(url, {}, {
            headers: header
        });
    }
);


export const {
    toggleOrderInspectionModal
} = orderInspectionSlice.actions;

export const orderInspectionSelector = (state: RootState) => state.OrderInspection;
export default orderInspectionSlice.reducer;
